export function formatProbability(value: number): string {
  if (!Number.isFinite(value)) return "Unavailable";
  return `${(value * 100).toFixed(1)}%`;
}

export function formatProbabilityLabel(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "Unavailable";
  const percentage = Math.round(value * 1000) / 10;
  return `${Number.isInteger(percentage) ? percentage.toFixed(0) : percentage.toFixed(1)}%`;
}

export function formatPointRange(low: number | null | undefined, high: number | null | undefined): string {
  if (low === null || low === undefined || high === null || high === undefined) return "Unavailable";
  return `${formatProbabilityLabel(low)}–${formatProbabilityLabel(high)}`;
}

export function formatSignedPoints(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "Unavailable";
  const points = value * 100;
  const rounded = Number.isInteger(points) ? points.toFixed(0) : points.toFixed(1);
  if (points === 0) return "0";
  return `${points > 0 ? "+" : "−"}${Math.abs(Number(rounded))}`;
}

export function formatDivergence(low: number | null | undefined, high: number | null | undefined): string {
  if (low === null || low === undefined || high === null || high === undefined || !Number.isFinite(low) || !Number.isFinite(high)) {
    return "Divergence unavailable";
  }

  const lowPoints = Math.round(low * 100);
  const highPoints = Math.round(high * 100);
  if (lowPoints < 0 && highPoints <= 0) return `${Math.abs(highPoints)}–${Math.abs(lowPoints)} pts below`;
  if (lowPoints >= 0 && highPoints > 0) return `+${lowPoints} to +${highPoints} pts above`;
  return "No material gap";
}

export function formatFeaturedDivergence(low: number | null | undefined, high: number | null | undefined): string {
  return formatDivergence(low, high).replace(/^\+(\d+) to \+(\d+) pts above$/, "$1–$2 pts above");
}

export function formatTimestamp(value: string | null): string {
  if (!value) return "Unavailable";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Unavailable";
  return new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "UTC",
  }).format(date);
}

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return "Unavailable";
  }
  return new Intl.NumberFormat("en", { maximumFractionDigits: 0 }).format(value);
}

export function detectorLabel(detector: string): string {
  return detector || "Unclassified";
}

export function hashPrefix(hash: string): string {
  return hash ? hash.slice(0, 12) : "Unavailable";
}

export function marketSlug(provider: string, marketId: string): string {
  return `${provider}-${marketId}`
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
